import React from 'react'
import Chart from './Chart'

export default function () {
  return <Chart />
}
